import {Injectable} from '@angular/core';
import {Headers} from '@angular/http';
import {LoginPage} from '../../pages/login/login';
import {SessionStorageService} from './sessionStorage.service';
import {App} from 'ionic-angular';
import {ToolsService} from './tools.service';

@Injectable()
export class ModelService {
  public ssService = new SessionStorageService();
  public formDataHeaders = new Headers({
    'Content-Type': 'application/x-www-form-urlencoded'
  });

  get Routing() {
    return window['Routing'];
  }

  constructor(protected readonly tools: ToolsService) {
  }

  protected handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

  getFormData(object) {
    const formData = [];
    Object.keys(object).forEach(key =>
      formData.push(encodeURIComponent(key) + '=' + encodeURIComponent(object[key]))
    );
    return formData.join('&');
  }

  // expire(lsService, http, app) {
  //   let delay = lsService.getOauthToken() && lsService.getOauthToken().expires_in ? lsService.getOauthToken().expires_in : 3600;
  //   let secondes = 300; /* in s (5 min) */
  //   let minutes = (delay - secondes) / 60; /* in min */
  //   let ONE_HOUR = minutes * 60 * 1000; /* in ms */
  //
  //   if ((new Date().getTime()) - parseInt(lsService.getExpireOauthToken()) > ONE_HOUR) {
  //     this.refreshToken(lsService.getOauthToken(), http)
  //       .subscribe(
  //         data => {
  //           lsService.setOauthToken(data);
  //         },
  //         error => {
  //           console.error('Delay', error);
  //           this.logOut(lsService, app);
  //         }
  //       );
  //   }
  // };

  // refreshToken(oauthToken, http) {
  //   const url = this.Routing.generate('fos_oauth_server_token', {'_format': 'json'}, true);
  //   let formData: string;
  //
  //   let credentials = {
  //     client_id: this._client_id,
  //     client_secret: this._client_secret,
  //     grant_type: 'refresh_token',
  //     refresh_token: oauthToken.refresh_token,
  //   };
  //
  //   formData = this.getFormData(credentials);
  //
  //   return http
  //     .post(url, formData, {headers: this.formDataHeaders})
  //     .map(res => res.json());
  // }

  logOut(app: App) {
    this.tools.localStorageService.removeOauthToken();
    this.ssService.removeBlogArticleFilters();
    this.tools.pushService.cleanExternalUserId();
    app.getRootNav().setRoot(LoginPage);
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/model.service.ts